import { CalendarOptions } from '@fullcalendar/core';
import nlLocale from '@fullcalendar/core/locales/nl';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import { updateEventTimeSpan } from './updateEventTimeSpan';
import { getView } from './getView';
import { openNewEventModal } from './openNewEventModal';
import moment from 'moment';
import { eventClickHandler } from './EventHandlers/handleEventClick';
import { setWeekendColors } from './Utils/setWeekendColors';

export function getCalendarOptions(agendaEl: HTMLDivElement) {
    const url = agendaEl.dataset.tableName;
    const eventSourceUrl = `/agenda/${url}`;
    const eventRecordUrl = `/data/${url}`;
    const filterColumnName = agendaEl.dataset.filterColumnName;
    var employeeId;
    var isEditableDate;
    document.addEventListener('selectedEmployeeChanged', function (event) {
        const customEvent = event as CustomEvent;
        const { selectedEmployee, isContentEditableDate } = customEvent.detail;
        employeeId = selectedEmployee;
        isEditableDate = isContentEditableDate;
    });

    const calendarOptions: CalendarOptions = {
        plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
        initialView: getView(window.innerWidth),
        height: 'auto',
        slotMinTime: '06:00:00',
        slotMaxTime: '21:00:00',
        eventOrder: ["title"],
        expandRows: true,
        allDaySlot: false,
        editable: true,
        eventResizableFromStart: true,
        locale: nlLocale,
        selectable: true,
        slotDuration: '00:05:00',
        slotLabelInterval: '01:00:00',
        eventSources: [
            {
                url: eventSourceUrl,
                method: 'GET',
            },
        ],
        headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'timeGridDay,timeGridWeek,listWeek',
        },
        slotLabelFormat: {
            hour: '2-digit',
            minute: '2-digit',
            omitZeroMinute: false,
            meridiem: 'short',
            hour12: false,
        },
        eventDidMount: function (info) {
            info.el.setAttribute('data-event-title', info.event.title);
            info.el.setAttribute('data-event-start', info.event.start.toISOString());
            if (info.event.end) {
                info.el.setAttribute('data-event-end', info.event.end.toISOString());
            }
            info.el.addEventListener('click', () => {
                eventClickHandler(info, eventRecordUrl);
            });
        },
        eventResize: function (arg) {
            updateEventTimeSpan(arg, eventSourceUrl);
        },
        eventDrop(arg) {
            updateEventTimeSpan(arg, eventSourceUrl);
        },
        select: function (info) {
            const isDateEditable = (isEditableDate && info.startStr > isEditableDate) || isEditableDate == undefined;
            if (!isDateEditable) {
                return;
            }

            const validationFnName = agendaEl.dataset.selectValidation;
            const validationFn = validationFnName ? window[validationFnName] : null;

            const canCreateEvent = validationFn
                ? validationFn(employeeId, info.startStr)
                : true;

            if (canCreateEvent) {
                openNewEventModal(
                    eventRecordUrl,
                    info.startStr,
                    info.endStr,
                    employeeId,
                    filterColumnName ?? "[Employees_EmployeeId].[EmployeeId]"
                );
            }
        },
        dayCellDidMount: function (info) {
            setWeekendColors(info);
        },
        dayHeaderFormat: function (date) {
            return moment(date.date).locale(date.localeCodes).format('ddd Do');
        },
    };
    return calendarOptions;
}